import { DOM, flow, IOO, pipe, RNEA } from '@packages/prelude'

const isTouchDevice = (): boolean => window.matchMedia('(hover: none)').matches

const initFlipHint = (card: HTMLElement): void => {
  if (!isTouchDevice()) return

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry?.isIntersecting !== true) return
      card.classList.add('is-hinting')
      card.addEventListener('animationend', () => card.classList.remove('is-hinting'), { once: true })
      observer.disconnect()
    },
    { threshold: 0.5 }
  )

  observer.observe(card)
}

const initCardFlip = (card: HTMLElement): void => {
  pipe(
    IOO.of(card),
    IOO.chainFirst(card =>
      pipe(
        card,
        DOM.querySelectorAll('.card-flip-back a'),
        IOO.map(RNEA.map(link => link.addEventListener('click', e => e.stopPropagation())))
      )
    ),
    IOO.chainFirst(card =>
      pipe(
        card,
        DOM.addEventListener('click')(() => () => card.classList.toggle('is-flipped')),
        IOO.fromIO
      )
    ),
    IOO.chainFirstIOK(card => () => initFlipHint(card))
  )()
}

const initAllCardFlips = (): void => {
  pipe(
    IOO.of({ document }),
    IOO.chain(
      ({ document }) =>
        pipe(document, DOM.querySelectorAll('.card-flip')) as unknown as IOO.IOOption<RNEA.ReadonlyNonEmptyArray<HTMLElement>>
    ),
    IOO.chain(flow(RNEA.map(initCardFlip), IOO.of))
  )()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllCardFlips)
} else {
  initAllCardFlips()
}
